<template lang="pug">
.v-field-check-list.field-check-list(:class="{'field-check-list--disabled': field.disabled}, field.className")
	label.field-check-list__label(v-if="field.label" :id="uniqueId")
		| {{field.label}}
		span.field-text__star(v-if="field.required") *
	template(v-if="field.custom" )
		.field-check-list__item.flc(v-for="(option, index) in field.options" :key="option.value + '-' + index" )
			v-field-custom-checkbox(
				:true-value="option.value"
				:item="option.item"
				:disabled="option.disabled || field.disabled"
				v-model="localValue"
				@update:model-value="handleInput"
				:radio="radio")
	template(v-else)
		.field-check-list__item.flc(v-for="(option, index) in field.options" :key="option.value + '-' + index")
			v-field-checkbox(
					:true-value="option.value"
					:text="option.text"
					:note="option.note"
					:number="option?.number"
					:icon="option?.icon"
					:disabled="option.disabled || field.disabled"
					v-model="localValue"
					@update:model-value="handleInput"
					:radio="radio")
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';

export default {
	props: {
		radio: {
			type: Boolean,
			default: false
		},

		field: {
			type: Object,
			required: true,
			default: null
		},

		modelValue: {
			type: [Object, String, Number],
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: null,
			open: false,
			uniqueId: uniqueId('field-')
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		}
	},

	created() {
		this.updateLocalValue();
	},

	methods: {
		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		handleInput() {
			this.$emit('update:model-value', this.localValue);
		}
	},
};
</script>
